import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import { CaptureConsole as CaptureConsoleIntegration } from "@sentry/integrations";

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import {
  setPropertiesForChannel,
  setImageBaseUrls,
} from "./store/init/initSlice";
import { setApiConfigs } from "./store/requests/requestsSlice";
import store from "./store/store";
import { observeStore } from "./store/observeStore";
import { setStoredState } from "./store/storedState";
import { BFC_SPA_Uterum } from "./constants/constants";

const rootElement = document.getElementById("bfc-single-page-app");
const root = createRoot(rootElement);

let channelId = rootElement.getAttribute("data-channel-id");
if (
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_LOCALHOST_CHANNEL_ID
) {
  channelId = process.env.REACT_APP_LOCALHOST_CHANNEL_ID;
}

if (process.env.REACT_APP_SCENSUM_ENV === "production") {
  Sentry.init({
    dsn: "https://47f3b1862b7b992931b4fc76e2f9e19e@o4505590205579264.ingest.sentry.io/4506262955294720",
    integrations: [
      new Sentry.BrowserTracing(),
      new CaptureConsoleIntegration({
        levels: ["warn", "error"],
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
  });
}

!rootElement && console.error("React root element is missing");

!channelId && console.error("Scensum channel id is missing");

// Get assetBaseUrl
const assetBaseUrl = rootElement.getAttribute("data-asset-base-url");

!assetBaseUrl && console.error("Scensum asset_baseurl is missing");

const selectUterum = (state) => state.Uterum;
const onUterumChange = (Uterum) => {
  setStoredState(BFC_SPA_Uterum, Uterum);
};

// Observe store for changes in Uterum --> setStoredState on change
observeStore(store, onUterumChange, selectUterum);

// Get articleImageBaseUrl
const articleImageBaseUrl = rootElement.getAttribute(
  "data-article-image-base-url"
);
!articleImageBaseUrl &&
  console.error("BFC SPA: Scensum article_image_base_url is missing");

store.dispatch(setPropertiesForChannel(channelId));
store.dispatch(setApiConfigs(channelId));
store.dispatch(
  setImageBaseUrls({
    assetBaseUrl,
    articleImageBaseUrl,
  })
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
